import React from "react";

import { VehicleType } from "@busbud/int-schemas/lib/vehicles";
import type { MappedOperator } from "@busbud/int-schemas/udm";

import { getDayDifference } from "@app/helpers/date-helper";
import type { NapiOperator } from "@app/types/napi-types";

import type { TransferStop as TransferStopType } from "../types";

import { TransferAlert } from "./transfer-alert";
import { GenericStop } from "../generic-stop";
import { VehicleIcon } from "../vehicle-icon";

interface Props {
  leg_departure_time: string | null;
  hide_location?: boolean;
  hide_time?: boolean;
  operator?: NapiOperator | MappedOperator;
  stop: TransferStopType;
}

export const TransferStop: React.FC<Props> = ({
  hide_location,
  hide_time,
  leg_departure_time,
  operator,
  stop
}) => {
  if (!stop.arrival_time || !stop.departure_time) {
    return null;
  }

  // difference from start of trip to arrival at transfer stop
  const arrival_day_difference = !!leg_departure_time
    ? getDayDifference(leg_departure_time, stop.arrival_time)
    : null;

  // difference from start of trip to departure from transfer stop
  const departure_day_difference = !!leg_departure_time
    ? getDayDifference(leg_departure_time, stop.departure_time)
    : null;

  return (
    <>
      <GenericStop
        day_difference={arrival_day_difference}
        hide_location={hide_location}
        hide_time={hide_time}
        time={stop.arrival_time}
        name={stop.arrival_name}
        city_name={stop.arrival_city_name}
        lat={stop.arrival_lat}
        lon={stop.arrival_lon}
        fallback_name={stop.arrival_name}
        stop_location_type={stop.stop_location_type}
      />
      <TransferAlert transfer={stop} />
      <GenericStop
        day_difference={departure_day_difference}
        icon={
          <VehicleIcon
            type={stop.departure_vehicle ?? VehicleType.Bus}
            color="icon.primary.opaque"
            size="MD"
          />
        }
        operator={operator}
        hide_location={hide_location}
        hide_time={hide_time}
        time={stop.departure_time}
        fallback_name={stop.departure_name}
        vehicle_type={stop.departure_vehicle}
        stop_service_name={stop.service_name}
        stop_service_number={stop.service_number}
        name={stop.departure_name}
        city_name={stop.departure_city_name}
        lat={stop.departure_lat}
        lon={stop.departure_lon}
        duration={stop.duration}
        stop_location_type={stop.stop_location_type}
      />
    </>
  );
};
